<template>
  <div>
    <Examples/>
    <CategoryLookup/>
    <div class="columns m-2">
      <div class="column mt-2">
        <b-field>
          <b-checkbox v-model="isDebug">Debug mode</b-checkbox>
        </b-field>
        <b-field id="query" type="is-primary" label="Ask Dmitri to solve a problem for you.">
          <b-input maxlength="1000" rows=8 type="textarea" v-model="query"></b-input>
        </b-field>
        <b-button  id="go" type="is-primary is-small" v-on:click="doQuery">Go!</b-button>
      </div>
      <div class="column mt-2">
        <div v-if="debugOutput">
          <b-message class="mt-4">
            {{debugOutput}}
          </b-message>
        </div>
      </div>
    </div>
    <div class="loading">
        <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </div>
    <div class="column">
      <div v-show="results === [] && !isLoading">
        <div>No results found.</div>
      </div>
      <div v-show="results && !isLoading">
        <Results v-bind:results="results" v-bind:columns="columns"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Results from '@/components/Results.vue';
import Examples from '@/components/Examples.vue';
import CategoryLookup from '@/components/CategoryLookup.vue';

const path = `${process.env.VUE_APP_API_URL}/query`;
// make a call to warm up the server
axios.get(path, {
  params: {
    query: '!ping',
    debug: false,
  },
}).catch((error) => {
  // eslint-disable-next-line
  console.error(error);
  this.isLoading = false;
});

export default {
  data() {
    return {
      query: '',
      isDebug: true,
      isLoading: false,
      results: null,
      columns: [],
      debugOutput: null,
    };
  },
  methods: {
    doQuery() {
      this.isLoading = true;
      this.results = [];
      axios.get(path, {
        params: {
          query: this.query,
          debug: this.isDebug,
        },
      })
        .then((res) => {
          this.results = res.data.results;
          this.columns = res.data.columns;
          this.debugOutput = res.data.debug_output;
          this.isLoading = false;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          console.log(error.response);
          if (error.response && error.response.status === 503) {
            this.debugOutput = "Your query has exceeded the system's 30 second time limit.";
          }
          this.isLoading = false;
        });
    },
  },
  components: {
    Results,
    Examples,
    CategoryLookup,
  },
};
</script>

<style scoped>
#query {
  margin-bottom: 0px;
}
</style>
